import { useActorRef } from '@xstate5/react';

import { loyaltyOffersModalMachine } from '../../machine';

// ─────────────────────────────────────────────────────────────────────────────

export const useInitLoyaltyOffersModalMachine = () => {
  return useActorRef(loyaltyOffersModalMachine);
};
